import {
  LBAlert,
  LBAlertCircleIcon,
  LBButton,
  LBDialog,
  LBDialogContent,
  LBDialogDescription,
  LBDialogFooter,
  LBDialogHeader,
  LBDialogTitle
} from '@linearb/buzz';
import useQueryParams from 'components/hooks/useQueryParams';
import { startCase } from 'lodash';

export const WITH_MULTI_SITES_ERROR_QS = 'withMultiSitesError';

const MultiSitesErrorModal = ({ sensorName }) => {
  const { useQueryParam, updateQueryParam } = useQueryParams();
  const withMultiOrgsErrorQs = useQueryParam(WITH_MULTI_SITES_ERROR_QS);

  const closeModal = () => updateQueryParam(WITH_MULTI_SITES_ERROR_QS, null);

  return (
    <LBDialog open={!!withMultiOrgsErrorQs} onOpenChange={closeModal}>
      <LBDialogContent className='min-w-[40rem]'>
        <LBDialogHeader>
          <LBDialogTitle className='flex items-center'>
            {startCase(sensorName)} connection
          </LBDialogTitle>
        </LBDialogHeader>
        <div className='flex items-center'>
          <LBAlert variant='destructive' className='flex items-center'>
            <LBAlertCircleIcon />
            <p className='relative right-1'>
              Failed to connect. Multiple sites found
            </p>
          </LBAlert>
        </div>
        <LBDialogDescription>
          To avoid issues, please connect using a dedicated{' '}
          <b>service account</b> with access to the correct site. <br />
          This ensures consistent, reliable integration.
        </LBDialogDescription>
        <LBDialogFooter className='mt-8'>
          <LBButton>Learn more</LBButton>
        </LBDialogFooter>
      </LBDialogContent>
    </LBDialog>
  );
};

export default MultiSitesErrorModal;
